// extracted by mini-css-extract-plugin
export default {"container":"SliderCard_container__QtO5L"};